import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProfileComponent } from '../../dialogs/profile/profile.component';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { OptionsDialogComponent } from 'src/app/dialogs/options-dialog/options-dialog.component';
import { ConsentDialogComponent } from 'src/app/dialogs/consent-dialog/consent-dialog.component';
import { PaymentDialogComponent } from 'src/app/dialogs/payment-dialog/payment-dialog.component';
import { MoreDialogComponent } from 'src/app/dialogs/more-dialog/more-dialog.component';
import { Asset } from 'src/app/interfaces/asset';
import { RateDialogComponent } from 'src/app/dialogs/rate-dialog/rate-dialog.component';
import { PersonInfoDialogComponent } from 'src/app/dialogs/person-info-dialog/person-info-dialog.component';
import { InputDialogComponent } from 'src/app/dialogs/input-dialog/input-dialog.component';
import { AvatarsDialogComponent } from 'src/app/dialogs/avatars-dialog/avatars-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  /** Open Add or Edit profile dialog.
   * @param profile Profile to edit *Optional
   */
  openProfileDialog(profile) {
    const dialogRef = this.dialog.open(ProfileComponent, {
      maxWidth: "100vw",
      width: "100vw",
      height: "100vh",
      panelClass: "profile-dialog",
      autoFocus: false,
      data: profile
    });

    return dialogRef.afterClosed();
  };

  /** Open confirm dialog.
   * @param data Configuration object {title,message,confirm,cancel}
   */
  openConfirmDialog(data) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: data,
      autoFocus: false,
      panelClass: "generic-dialog",
    });

    return dialogRef.afterClosed();
  }

  /** Open options dialog.
   * @param data Configuration object {title,message,confirm,cancel,selected,options}
   */
  openOptionsDialog(data) {
    const dialogRef = this.dialog.open(OptionsDialogComponent, {
      data: data,
      autoFocus: false,
      panelClass: "generic-dialog"
    });

    return dialogRef.afterClosed();
  }

  /** Open input dialog.
   * @param data Configuration object {title,message,confirm,cancel,type,inputTitle,regex}
   */
  openInputDialog(data) {
    const dialogRef = this.dialog.open(InputDialogComponent, {
      data: data,
      autoFocus: false,
      panelClass: "generic-dialog"
    });
    return dialogRef;//.afterClosed();
  }

  /** Open options dialog.
   * @param data Configuration object {avatars,selected}
   */
  openAvatarsDialog(data) {
    const dialogRef = this.dialog.open(AvatarsDialogComponent, {
      data: data,
      autoFocus: false,
      width: "100vw",
      height: "100%",
      maxWidth: "100vw"
    });

    return dialogRef.afterClosed();
  }

  /** Open consent dialog. */
  openConsentDialog() {
    const dialogRef = this.dialog.open(ConsentDialogComponent, {
      autoFocus: false,
      width: "70%",
      minHeight: "70vh",
      panelClass: "overflow-auto"
    });
    return dialogRef.afterClosed();
  }

  /** Open payment dialog.
   * @param data Configuration object {products,assetId,productsService}
   */
  openPaymentDialog(data) {
    const dialogRef = this.dialog.open(PaymentDialogComponent, {
      autoFocus: false,
      data: data,
      width: "100vw",
      maxWidth: "100vw",
      minHeight: "100vh",
      panelClass: "payment-dialog",
      disableClose: true
    });
    return dialogRef.afterClosed();
  }

  /** Open more info dialog.
   * @param {Object} asset
   */
  openMoreDialog(data: Asset) {
    this.dialog.open(MoreDialogComponent, {
      data: data,
      width: "100vw",
      maxWidth: "100vw",
      minHeight: "100vh",
      autoFocus: false,
      panelClass: ["more-dialog", "overflow-auto"],
    });
  }

  /** Open person info dialog.
   * @param {Object} persons
   */
  openPersonInfoDialog(data: any) {
    this.dialog.open(PersonInfoDialogComponent, {
      data: data,
      width: "100vw",
      maxWidth: "100vw",
      minHeight: "100vh",
      autoFocus: false,
      panelClass: ["more-dialog", "overflow-auto"],
    });
  }

  /** Open more info dialog.
   * @param {Object} asset
   * @returns dialogRef
   */
  openRateDialog(data: Asset) {
    const dialogRef = this.dialog.open(RateDialogComponent, {
      data: data,
      autoFocus: false,
      panelClass: "rate-dialog",
    });
    return dialogRef.afterClosed();
  }
}